((HpSlider, $) => {
  'use strict';

  let $slider;
  let $slider2;

  const cacheDom = () => {
    $slider = $('.hp-slider');
    $slider2 = $('.top-pornstars-slider');
  };

  const bindUIActions = () => {
    $slider.on('initialized.owl.carousel', () => {
      $slider.css('opacity', 1);
    });

    $slider2.on('initialized.owl.carousel', () => {
      $slider2.css('opacity', 1);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  HpSlider.init = init;

})(window.HpSlider = window.HpSlider || {}, $);
